/**
 * Feedback context capture — rolling buffers of console errors and network errors.
 *
 * Imported once in main.tsx to install the interceptors.
 * The FeedbackWidget reads the buffers when submitting.
 */

const MAX_CONSOLE_ERRORS = 10;
const MAX_NETWORK_ERRORS = 10;

// --- Console error capture ---

const consoleErrors: string[] = [];
const originalConsoleError = console.error;

console.error = (...args: unknown[]) => {
  consoleErrors.push(args.map(String).join(" "));
  if (consoleErrors.length > MAX_CONSOLE_ERRORS) consoleErrors.shift();
  originalConsoleError.apply(console, args);
};

export function getRecentConsoleErrors(): string[] {
  return [...consoleErrors];
}

// --- Network error capture ---

export type NetworkError = {
  url: string;
  status: number;
  method: string;
};

const networkErrors: NetworkError[] = [];

export function recordNetworkError(error: NetworkError): void {
  networkErrors.push(error);
  if (networkErrors.length > MAX_NETWORK_ERRORS) networkErrors.shift();
}

export function getRecentNetworkErrors(): NetworkError[] {
  return [...networkErrors];
}
